// Charge report monthly
import { API_BASE } from "../../config";
import { useEffect, useState } from "react";
import SummaryCard from "../../components/Air/paymentReports/Day/Card"
import DataSelector from "../../components/Air/paymentReports/Day/DataSelector";
import AdminLayout from "../../layout/AdminLayout"
import axios from "axios";

const PaymentByDay = () =>{

    const [data,setData] = useState(null)
 
    const handleData = async () =>{
        try {
            const res = await axios.get(`${API_BASE}/api/air-client/Today/current`)
             setData(res.data.clients);
        } catch (error) {
            console.log(error)
        }
    }
    useEffect(()=>{
        handleData();
    },[])

    return(
        <AdminLayout>
                 <div className="my-5 flex justify-center items-center">
                    {data && <SummaryCard data={data}/>}
                 </div>
                 <div>
                     {data && <DataSelector data={data}/>}
                 </div>
        </AdminLayout>
    );
}
export default PaymentByDay;
